module.exports = __webpack_public_path__ + "static/media/loading-spinner.5f5f6c26.gif";